import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'maplix-popup-fieldtype-file-upload',
  templateUrl: './popup-fieldtype-file-upload.component.html',
  styleUrls: ['./popup-fieldtype-file-upload.component.scss'],
})
export class PopupFieldtypeFileUploadComponent implements OnInit {
  @Input()
  public url: string;

  @Input()
  public extension: string;

  @Input()
  public mimeType: string;

  @Input()
  public fileName: string;

  @Output()
  private open: EventEmitter<string> = new EventEmitter();

  public loadedImages: string[] = [];

  public mode: string = 'link';

  private readonly NON_IMAGE_EXT = /\.(pdf|docx?|xlsx?|pptx?|zip|rar|csv|txt|mp4|mp3|wav|json|xml)(\?|#|$)/i;

  constructor() {}

  ngOnInit(): void {
    if (this.url && !this.extension) {
      this.mode = this.resolveMode();
    }
  }

  private resolveMode(): string {
    if (this.NON_IMAGE_EXT.test(this.url)) {
      return 'link';
    }
    return 'probing';
  }

  public onProbeResult(result: 'image' | 'link'): void {
    this.mode = result;
  }

  public onOpenImage(image: string) {
    this.open.emit(image);
  }
}
